import { format, intervalToDuration, isAfter } from "date-fns";
import { ptBR } from "date-fns/locale";

type niceDateType = {
  dateString: string;
  language: string;
};

export const date = (
  dateString: string,
  options = { format: "dd/MM/yyyy" }
) => {
  return format(new Date(dateString), options.format, {
    locale: ptBR,
  });
};

export const dayOfWeek = (dateString: string, options = { format: "EEEE" }) => {
  return format(new Date(dateString), options.format, {
    locale: ptBR,
  });
};

export const niceDate = ({ dateString, language }: niceDateType): string => {
  const now = new Date();
  const target = new Date(dateString);

  const start = isAfter(now, target) ? target : now;
  const end = isAfter(now, target) ? now : target;

  const { years, months, days, hours, minutes } = intervalToDuration({ start, end });

  const justNowMessages: Record<string, string> = {
    en: "just now",
    pt: "agora mesmo",
    es: "ahora mismo",
    de: "jetzt",
  };

  const units: Record<string, Record<string, [string, string]>> = {
    en: {
      years: ["year", "years"],
      months: ["month", "months"],
      days: ["day", "days"],
      hours: ["hour", "hours"],
      minutes: ["minute", "minutes"],
    },
    pt: {
      years: ["ano", "anos"],
      months: ["mês", "meses"],
      days: ["dia", "dias"],
      hours: ["hora", "horas"],
      minutes: ["minuto", "minutos"],
    },
    es: {
      years: ["año", "años"],
      months: ["mes", "meses"],
      days: ["día", "días"],
      hours: ["hora", "horas"],
      minutes: ["minuto", "minutos"],
    },
    de: {
      years: ["Jahr", "Jahre"],
      months: ["Monat", "Monate"],
      days: ["Tag", "Tage"],
      hours: ["Stunde", "Stunden"],
      minutes: ["Minute", "Minuten"],
    },
  };

  const langUnits = units[language] || units.pt;

  const parts = [
    { value: years, label: langUnits.years },
    { value: months, label: langUnits.months },
    { value: days, label: langUnits.days },
    { value: hours, label: langUnits.hours },
    { value: minutes, label: langUnits.minutes },
  ];

  const result = parts
    .filter(({ value }) => value && value > 0)
    .map(({ value, label }) => `${value} ${value === 1 ? label[0] : label[1]}`)
    .join(' ');

  return result || justNowMessages[language] || justNowMessages.pt;
};
export const secondsToHours = (second: number) => {
  const hours = second / 3600;
  const rhours = Math.floor(hours);
  const minutes = (hours - rhours) * 60;
  const rminutes = Math.round(minutes);

  return `${rhours.toString().padStart(2, "0")}:${rminutes
    .toString()
    .padStart(2, "0")}`;
};

export const expirationDaysText = (days_left_password: number) => {
  const suffixDays = days_left_password > 1 ? "dias" : "dia";

  return `Sua senha expira em ${days_left_password} ${suffixDays}.`;
};

